// extracted by mini-css-extract-plugin
export default {"galleryContainer":"styles_galleryContainer__8OEBy","gradfacesContainer":"styles_gradfacesContainer__p0cfi","gradfacesIcon":"styles_gradfacesIcon__7Hci0"};